import { useEffect, useRef } from "react";

interface Props {
  shown: number;
  total: number;
  noun: string;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  onLoadMore: () => void;
}

export function DataTableLoadMore({ shown, total, noun, hasNextPage, isFetchingNextPage, onLoadMore }: Props) {
  const sentinel = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined" || !sentinel.current) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting && hasNextPage && !isFetchingNextPage) onLoadMore();
    }, { threshold: 0.1 });
    observer.observe(sentinel.current);
    return () => observer.disconnect();
  }, [hasNextPage, isFetchingNextPage, onLoadMore]);

  return (
    <div className="flex items-center gap-3">
      <span>Showing {shown} of {total} {noun}</span>
      {hasNextPage && (
        <button
          type="button"
          onClick={onLoadMore}
          disabled={isFetchingNextPage}
          className="text-brand underline underline-offset-[3px] disabled:opacity-60"
        >
          {isFetchingNextPage ? "Loading…" : "Load more"}
        </button>
      )}
      <span ref={sentinel} aria-hidden className="inline-block size-px" />
    </div>
  );
}
